/**
 * Contém variáveis de ambiente para mais fácil utilização
 */
export const Environment = {
  /**
   * Configura a mensagem que será exibida dentro dos campos de pesquisa
   */
  INPUT_DE_BUSCA: 'Pesquisar...',
  /**
   * Configura o limite de registros a serem exibidos nas listagens
   */
  LIMITE_DE_LINHAS: 10,
  /**
   * Configura a mensagem que será exibida quando uma listagem estiver vazia
   */
  LISTAGEM_VAZIA: 'Nenhum registro encontrado.',

  /**
   * Indica modo de `prod` no azure.
   */
  IS_PRODUCTION: process.env.REACT_APP_ENV === 'prod',
  /**
   * Indica modo de `dev` no azure.
   */
  IS_DEV: process.env.REACT_APP_ENV === 'dev',
  /**
   * Indica modo de `development` na máquina local.
   */
  IS_DEVELOPMENT: process.env.REACT_APP_ENV === 'development',
  /**
   * Indica modo de `hml` no azure.
   */
  IS_HOMOLOG: process.env.REACT_APP_ENV === 'hml',

  API_GATEWAY: getUrlApiGateway(),

  URL_ORIGIN_DEBUG: getUrlOriginDebug(),

  URL_API: getUrlApi(),
};

function getUrlApiGateway() {
	if (process.env.REACT_APP_ENV === 'prod') {
		return 'https://api.gvdasa.com.br';
	}
	if (process.env.REACT_APP_ENV === 'hml') {
		return 'https://api-hml.gvdasa.com.br';
	}
	return 'https://api-dev.gvdasa.com.br';
}

function getUrlOriginDebug() {
	if (process.env.REACT_APP_ENV === 'prod' || process.env.REACT_APP_ENV === 'hml' || process.env.REACT_APP_ENV === 'dev') {
		return '';
	}
	return 'https://fin7-dev.painel-dev.gvdasa.com.br/';
}

function getUrlApi() {
	if (process.env.REACT_APP_ENV === 'prod') {
		return 'https://api.gvdasa.com.br/gestaoreservas/api/v1';
	}
	if (process.env.REACT_APP_ENV === 'hml') {
		return 'https://api-hml.gvdasa.com.br/gestaoreservas/api/v1';
	}
	return 'https://api-dev.gvdasa.com.br/gestaoreservas/api/v1';
}